import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { typePageConfig } from "./typePageConfig";

export const typeRecordDefinition: RecordDefinition = {
  path: "/type",
  entityName: "dwtype",
  listRoute: "/types",
  backTitle: "Back to types",
  allowedRoles: administratorRoles,
  config: typePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Type",
    newRecordTitle: "New Type",
  },
};
